export default {
    maxCount: 10
}
